import styled from "styled-components";

export const PageWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ChartCard = styled.div`
  border-radius: 12px;
  border: 1px solid #e9eaeb;
  padding: 20px;
`;

export const ContentGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const RightSidebarWrapper = styled.div`
  @media (max-width: 991px) {
    margin-top: 24px;
  }
`;

/* PG-2497: SEC 206(4)-1 compliance — must accompany any performance display
   so the disclaimer cannot be missed at the point of selection.
   Margins give the line breathing room when the parent doesn't supply its
   own flex gap (e.g. the backtest path inside StrategyDetail.jsx). */
export const PastPerformanceDisclaimer = styled.p`
  margin: 12px 0;
  padding: 0 4px;
  font-family: "Geist", sans-serif;
  font-size: 12px;
  font-style: italic;
  line-height: 18px;
  text-align: center;
  color: ${({ theme }) => theme.typography.color.secondary};
`;
